/** @jsxImportSource @emotion/react */
"use client";

import {
  matchSelectableGuide,
  useCurrentQueueItem,
  usePlayer,
} from "@packages/media";
import type { Track } from "@packages/sdk";
import { useRedirects, useRequestMe } from "@packages/sdk";

import { SelectLengthList } from "./SelectLengthList.emotion";

export const SelectLengthContent = () => {
  const { currentItem } = useCurrentQueueItem();
  const { redirectToSubscribe } = useRedirects();
  const { query: me } = useRequestMe();
  const player = usePlayer();
  if (currentItem?.type === "radio_song") return null;

  const currentGuide = currentItem?.prayer?.selectable_guides?.find((g) =>
    matchSelectableGuide(g.guide_ids, currentItem.selected_audio.guide_ids),
  );

  const lengths = currentGuide.tracks;

  return (
    <SelectLengthList
      selectedLength={currentItem?.selected_audio}
      setSelectedLength={(option) => {
        let newOption: Partial<Track>;
        if (typeof option === "function") newOption = option(null);
        else newOption = option;
        const hasAccess =
          typeof newOption.has_access !== "undefined"
            ? newOption.has_access
            : (newOption.paid && me?.data?.subscription) || !newOption.paid;
        if (hasAccess) return player.switchTo(newOption);
        return redirectToSubscribe({ newWindow: true });
      }}
      options={lengths}
    />
  );
};
